export const DEFAULT_DURATION = 30 * 60 * 1000;
export const DEFAULT_PICKER_MIN_TIME_OFFSET = 30 * 60 * 1000;
